export default {"src":"/login-app/[GIT_HASH]/_next/static/media/gantt_flat.039f59f5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};